<template>
<div>
<form>
  <div class="form-row">
    <div class="col">
      <input v-focus type="text" @input="msg=''" ref="numsco"  maxlength="4" v-on:keydown="keyHandler($event,'Num')" class="form-control" placeholder="Numero scontrino" v-model="creditNote.numsco">
      <small>es:0001</small>
    </div>
    <div class="col">     
      <input type="text" ref="znumber"  @input="msg=''"  v-on:keydown="keyHandler($event,'Num')" maxlength="4"  class="form-control" placeholder="Numero rapporto" v-model="creditNote.znumber">
      <small>es:0001</small>
    </div>
    <div class="col">
     
      <input type="text" ref="datasco" @input="msg=''"  v-on:keydown="keyHandler($event,'Num')"  maxlength="6"  class="form-control" placeholder="Data scontrino" v-model="creditNote.datasco">
      <small>GGMMAA</small>
     
    </div>
  </div>
  <span style="color:red">{{msg}}</span>
</form>

</div>

</template>

<script>

import keyHandler         from '@/components/mixins/keyHandler'
export default {
   mixins: [keyHandler],

  data() {
    return {
      
      creditNote : {},
      msg        : ''

      
            
    };
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        
        
        el.focus();
      }
    }
  },
  computed:
    {

    },
  created () 
      {

      },  
  methods: 
  {
   
    checkData()
    {
      this.msg = ''
     
      if(!this.creditNote.numsco)
      {
        
        this.msg = 'Numero scontrino non valido.'

        this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        
        return 
      }
      else if(this.creditNote.numsco.length !=4 )
      {
        this.msg = 'Numero scontrino non valido.'
         this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        return
        
      }
      else if(parseInt(this.creditNote.numsco)==0)
      {
        this.msg = 'Numero scontrino non valido.'
         this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        return 
        
      }

      else if(!this.creditNote.znumber)
      {
        this.msg = 'Numero rapporto non valido.'
         this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(this.creditNote.znumber.length !=4)
      {
        this.msg = 'Numero rapporto non valido.'
        this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(parseInt(this.creditNote.znumber)  == 0)
      {
        this.msg = 'Numero rapporto non valido.'
        this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(!this.creditNote.datasco)
      {
        this.msg = 'Data scontrino non valida.'
        this.$nextTick(function () {
        
            this.$refs['datasco'].focus()
        
        })
        return
        
      }
      else if (this.creditNote.datasco.length != 6)
      {
        this.msg = 'Data scontrino non valida.'
        this.$nextTick(function () {
        
            this.$refs['datasco'].focus()
        
        })
        
      }  

      
      if(!this.msg)
      {
          this.$emit('update',this.creditNote)
      }
    },
   

    
}
}

</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 10px;
}








</style>


